<h2 mat-dialog-title>
    {{title}}
    <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
    <div *ngFor="let line of lines">{{line}}</div>
    <mat-checkbox color="primary" *ngIf="extraConfirm" class="extra-confirm" [checked]="extraConfirmPassed" (change)="extraConfirmChange($event)">{{extraConfirmMessage}}</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [disabled]="!conditionsApplied" [mat-dialog-close]="yesValue">{{yesCaption}}</button>
    <button mat-stroked-button color="primary" mat-dialog-close>{{noCaption}}</button>
</mat-dialog-actions>